import { Injectable } from "@angular/core";
import { ApplicationInsights, Util } from "@microsoft/applicationinsights-web";
import {
    ActivatedRouteSnapshot,
    ResolveEnd,
    Router,
    NavigationStart,
    NavigationEnd,
    RouterEvent
} from "@angular/router";
import { Subscription } from "rxjs";

@Injectable()
export class AppInsightsService {
    private appInsights = new ApplicationInsights({
        config: {
            instrumentationKey: "eae1d57a-894f-4343-81ed-eed9362909bf" // add your app insight key here
        }
    });

    constructor(private router: Router) {
        this.appInsights.loadAppInsights();
        this.router.events.subscribe(
            (event: RouterEvent) => {
                if (event instanceof NavigationStart) {
                    this.appInsights.context.telemetryTrace.traceID = Util.newId();
                    this.appInsights.context.telemetryTrace.name = event.url;

                    this.appInsights.startTrackEvent(event.url);
                    
                    console.log("NavigationStart");
                }

                if (event instanceof ResolveEnd) {
                    const activatedComponent = this.getActivatedComponent(
                        event.state.root
                    );

                    if (activatedComponent) {
                        this.logPageView(event.urlAfterRedirects);
                    }

                    console.log("ResolveEnd");
                }

                if (event instanceof NavigationEnd) {
                    this.appInsights.stopTrackEvent(event.url, { type: 'PAGE LOAD TIME' });

                    console.log("NavigationEnd");
                }
            }
        );
    }

    public setUserId(userId: string) {
        this.appInsights.setAuthenticatedUserContext(userId);
    }

    public clearUserId() {
        this.appInsights.clearAuthenticatedUserContext();
    }

    public logPageView(uri: string) {
        this.appInsights.trackPageView({
            "uri": uri
        });
    }

    private getActivatedComponent(snapshot: ActivatedRouteSnapshot): any {
        if (snapshot.firstChild) {
            return this.getActivatedComponent(snapshot.firstChild);
        }

        return snapshot.component;
    }

    private getRouteTemplate(snapshot: ActivatedRouteSnapshot): string {
        let path = "";
        if (snapshot.routeConfig) {
            path += snapshot.routeConfig.path;
        }

        if (snapshot.firstChild) {
            return path + this.getRouteTemplate(snapshot.firstChild);
        }

        return path;
    }
}